import { FC } from 'react'

import { Button, Cluster, PlusIcon } from '@forto-dev/phoenix-ui-core'

import { useLocalisation } from '@/utils/localisation'

import { useLocationSelectorContext } from '../context/useLocationSelectorContext'
import { useLocationSelectorDispatchContext } from '../context/useLocationSelectorDispatchContext'

export const LocationSearchFooter: FC = () => {
  const { manualActionProps } = useLocationSelectorContext()
  const { onAddNew } = useLocationSelectorDispatchContext()
  const { translate } = useLocalisation()
  return (
    <Cluster y="center" x="center" fullWidth>
      <Button
        variant="ghost"
        onMouseDown={() => {
          onAddNew()
        }}
      >
        <Cluster gap={4} y="center" x="center" fullWidth>
          <PlusIcon /> {manualActionProps?.buttonLabel ?? translate('locations.add.button')}
        </Cluster>
      </Button>
    </Cluster>
  )
}
